export const getHourAndMinuteFromNumber = (value: number): number[] => {
    const hour = Math.trunc(value);
    const minute = Math.trunc((value - hour) * 60);
    return [hour, minute];
};
